import { endOfMonth, startOfMonth } from 'date-fns';
import { supabase } from './supabase';

function monthRangeIso(): { start: string; end: string } {
  const now = new Date();
  return {
    start: startOfMonth(now).toISOString(),
    end: endOfMonth(now).toISOString(),
  };
}

/** Product sales revenue this month (retail POS — excludes internal withdrawals). */
export async function fetchInventorySalesThisMonth(businessId: string): Promise<number> {
  if (!supabase) throw new Error('Database connection not available');

  const { start, end } = monthRangeIso();
  const { data, error } = await supabase
    .from('product_sales')
    .select('total_amount')
    .eq('business_id', businessId)
    .gte('created_at', start)
    .lte('created_at', end);

  if (error) throw error;

  return (data ?? []).reduce((sum, row) => sum + (Number(row.total_amount) || 0), 0);
}

/** Units consumed internally this month (withdrawals not tied to a product sale). */
export async function fetchInventoryConsumedUnitsThisMonth(businessId: string): Promise<number> {
  if (!supabase) throw new Error('Database connection not available');

  const { start, end } = monthRangeIso();
  const { data, error } = await supabase
    .from('stock_transactions')
    .select('quantity, stock_items!inner(business_id)')
    .eq('type', 'sale')
    .is('product_sale_id', null)
    .eq('stock_items.business_id', businessId)
    .gte('created_at', start)
    .lte('created_at', end);

  if (error) throw error;

  return (data ?? []).reduce((sum, row) => sum + Math.abs(Number(row.quantity) || 0), 0);
}
